import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Buyer } from 'src/app/core/buyers.service';

@Component({
  selector: 'app-buyer-details-general-document',
  templateUrl: './buyer-details-general-document.component.html',
  styleUrls: ['./buyer-details-general-document.component.scss'],
})
export class BuyerDetailsGeneralDocumentComponent {
  @Input() buyer?: Buyer;
  @Input() buyer_document_url?: string;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  onDownloadClick(): void {
    window.open(this.buyer_document_url, '_blank');
  }
}
